
function  getElementDimensions(element) {
//  console.log('getting element dimensions: ', element)
  return {
    width: element.clientWidth,
    height: element.clientHeight
  }
}

function  setElementDimensions(element, rect) {
  //console.log('setting dimensions of an element: ', element)

  if (rect.hasOwnProperty("height")) {
    element.style.height = rect.height + "px";
  }

  if (rect.hasOwnProperty("width")) {
    element.style.width = rect.width + "px";
  }
}

function setElementPosition(element, rect) {

  if (rect.hasOwnProperty("x")) {
    element.style.left = rect.x + "px";
  }

  if (rect.hasOwnProperty("y")) {
    element.style.top = rect.y + "px";
  }

}

function hideElement(element) {
  element.style.display = "none";
  element.style.visibility = "hidden";
}

function showElement(element) {
  element.style.display = "block";
  element.style.visibility = "visible";
}

function showOrHideElement(element) {
  if (element.style.visibility == "visible") {
    hideElement(element);
  } else {
    showElement(element);
  }
}

function isElementHidden(element) {
  return (element.style.display == "none" && element.style.visibility == "hidden");
}

function isElementVisible(element) {
  return (element.style.display != "none" && element.style.visibility == "visible")
}

// this relies on documentOffset properties defined on object ...
function getElementPosition(element) {
  //var offset = $(document.body).offset();

//  return {x: offset.left, y: offset.top};
  return {x: element.documentOffsetLeft, y: element.documentOffsetTop};
}

function getScrollHandleSize() {

  var $outer = $('<div>').css({
    visibility: 'hidden',
    width: 100,
    overflow: 'scroll'
  }).appendTo('body');

  var widthWithScroll = $('<div>').css({ width: '100%' }).appendTo($outer).outerWidth();

  $outer.remove();

  // compute area occupied by scroll handle
  var size = 100 - widthWithScroll + 1;

  //console.log('detected scroll size: ', size, 18)

  // default scroll size is set to 18
  return (size > 18 ? size : 18);
}



module.exports = {
    getElementDimensions: getElementDimensions,
    setElementDimensions: setElementDimensions,
    setElementPosition: setElementPosition,
    hideElement: hideElement,
    showElement: showElement,
    showOrHideElement: showOrHideElement,
    getElementPosition: getElementPosition,
    getScrollHandleSize: getScrollHandleSize,
    isElementHidden: isElementHidden,
    isElementVisible: isElementVisible
}



// this will be singleton, there is no point in creating another instance



// WEBPACK FOOTER //
// ./app/react/tools/DOMTools.jsx